import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Breadcrumb.css";

const Breadcrumb = () => {
  const location = useLocation();
  const product = location.state;

  return (
    <div className="breadcrumb">
      
      <Link to="/" className="crumb">Home</Link>

      <span className="arrow">›</span>

      <Link to="/shop" className="crumb">Shop</Link>

<span className="divider"></span>
      <span className="current">
        {product?.name || "Product"}
      </span>

    </div>
  );
};

export default Breadcrumb;